import * as React from "react";
const SvgFiRrMosqueMoon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mosque-moon_svg__a)">
      <path
        fill="#062147"
        d="M21 22h-.949C21.279 20.646 22 19.09 22 17.61c0-4.285-3.708-6.157-6.415-7.523-.731-.37-1.718-.87-2.234-1.287-.032-.081-.229-.628-.312-1.807a3.8 3.8 0 0 0 2.887-1.6.395.395 0 0 0-.383-.618q-.262.04-.537.04a3.822 3.822 0 0 1-3.782-4.36.395.395 0 0 0-.619-.382 3.8 3.8 0 0 0-1.593 3.422c.106 1.3.884 2.414 1.976 3.019-.053 1.624-.31 2.248-.31 2.248l.008.007c-.505.422-1.524.939-2.272 1.316-2.707 1.367-6.415 3.239-6.415 7.523 0 1.48.721 3.036 1.949 4.39h-.949a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2zM4 17.61c0-3.054 2.824-4.48 5.316-5.738 1.039-.524 2.003-1.011 2.684-1.597.681.586 1.645 1.072 2.684 1.597C17.176 13.13 20 14.556 20 17.61c0 1.457-1.171 3.169-2.987 4.39H6.987C5.171 20.779 4 19.068 4 17.61"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mosque-moon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMosqueMoon;
